import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';

import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from "../../actions/root_url";
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';

const { Selectors } = Data;



export class PriceTableModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},

        }
    }

    componentDidMount() {
        this.props.fetchPT(this.props.fjCustomerId, this.props.type).then((response) => {
            if (response.data) {
                this.initializeModal(response.data);
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            } else {
                alert(JSON.stringify(err.data));
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (array) => {
        let index = 0;
        let formatter = [];
        if (array && array.length > 0) {
            array.map(r => {
                formatter.push({ Idx: index++, customer: r.customer, id: r.id, price: r.price, product: r.product, product_name: r.product_name, customer_price: r.customer_price, driver_price: r.driver_price });
            })
        } else {
            formatter.push({ Idx: 0, name: "", note: "", customer: this.props.fjCustomerId });
        }
        this.setState({
            rows: formatter,
            selectedRows: [],
            editedRows: [],
        });
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            // r.recreate = false;
        });
        this.props.updatePT(this.props.fjCustomerId, this.state.rows, this.props.type).then((response) => {
            // alert(JSON.stringify(response.data));
            alert("Price Table Updated");
            this.props.closePTModal();
          }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            } else {
              alert(JSON.stringify(err.data));
            }
          });
        // this.props.onSave(this.state.rows);
    }

    // clickNew(e) {
    //     e.preventDefault();
    //     let rows = Selectors.getRows(this.state);
    //     let index = rows.length;
    //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
    //     rows.push(newRow);
    //     let editedRows = [...this.state.editedRows];
    //     editedRows.push(newRow)
    //     this.setState({ rows, editedRows })
    // }

    // deleteCategory(e) {
    //     e.preventDefault();
    //     let rows = [...this.state.rows];
    //     let editedRows = [...this.state.editedRows];
    //     let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

    //     if (this.state.selectedRows[0].id) {
    //         this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
    //             alert("Agent Deleted");
    //             rows.splice(index, 1);
    //             index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
    //             editedRows.splice(index, 1);
    //             this.setState({ rows, editedRows, selectedRows: [] })
    //             // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
    //             //     if (response.data) {
    //             //         this.initializeModal(response.data);
    //             //     }
    //             // }, (err) => {
    //             //     if (err.status === 500 || err.status === 404) {
    //             //         alert("Server error, please refresh page. If problem persists, contact administrator.");
    //             //     }
    //             // });
    //         }, (err) => {
    //             if (err.status === 500 || err.status === 404 || err.status === 405) {
    //                 alert("Error cannot delete agent.");
    //             }
    //         });
    //     }

    //     // rows.splice(index, 1);
    //     // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
    //     // editedRows.splice(index, 1);
    //     // this.setState({ rows, editedRows, selectedRows: [] })
    // }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }


          const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
            } else {
              delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
          }


        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        // const columns = !isMAG ? [
        const columns = true ? [
            {
                key: 'product_name',
                name: <Translate value="service" />,
                resizable: true,
                // sortable: true,
                filterable: true,
                // editable: true,
                width: 320,
            },
            {
                key: 'price',
                name: <Translate value="price" />,
                resizable: true,
                // sortable: true,
                // filterable: true,
                editable: true,
                width: 230,
            },
        ] : [
            {
                key: 'product_name',
                name: <Translate value="service" />,
                resizable: true,
                // sortable: true,
                filterable: true,
                // editable: true,
                width: 300,
            },
            {
                key: 'customer_price',
                name: <Translate value="customer_price" />,
                resizable: true,
                // sortable: true,
                // filterable: true,
                editable: true,
                width: 130,
            },
            {
                key: 'driver_price',
                name: <Translate value="driver_price" />,
                resizable: true,
                // sortable: true,
                // filterable: true,
                editable: true,
                width: 130,
            },
        ];

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '550px', marginLeft: '25px' }}>
                        <ReactDataGrid
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={400}
                            rowHeight={25}
                            headerRowHeight={45}
                            // enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            // rowSelection={{
                                // showCheckbox: true,
                                // onRowsSelected,
                                // onRowsDeselected,
                                // selectBy: {
                                //     isSelectedKey: 'isSelected'
                                // }
                            // }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        return (
            <div>
                <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    {/* <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button> */}
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button> */}
                </ButtonToolbar>
                <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderAgentTable()}
                        </span>
                    </Col>
                </Row>

                <Row className="centerStyle" style={{ marginTop: '20px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSave(e); }}
                    >
                        <Translate value="save" />
                    </Button>
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>
            </div>
        );
    }
}

export default PriceTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/priceTableModal.jsx